import { useEffect, useState } from 'react';

export default function LoadingText({ text = 'Loading' }: { text?: string }) {
  const [numberOfDots, setNumberOfDots] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setNumberOfDots((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  return (
    <span>
      {text}
      {Array(numberOfDots).fill('.')}
    </span>
  );
}
